<template>
  <div id="app" class="container">
    <router-view
      :key="locale"
      :language="locale"
      @changeLanguage="changeLanguage"
    />
  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted, vueVersion } from "./TUIKit/adapter-vue";
import { TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import router from "./router/index";
import { Message } from "element-ui";
import { SDKAppID } from "./main";
import { TUILogin } from "@tencentcloud/tui-core";
const locale = ref<string>("zh");
TUIStore.watch(StoreName.USER, {
  kickedOut: (value: string) => {
    if (value && router.currentRoute.name !== "Login") {
      Message.error({
        message: "您已被挤下线，请重新登录！",
      });
      localStorage.removeItem("TUIKit-userInfo");
      window.location.assign("/login");
      localStorage.clear();
    }
  },
});
onMounted(() => {
  let tencent_accid = localStorage.getItem("tencent_accid");
  let tencent_token = localStorage.getItem("tencent_token");
  const loginInfo: any = {
    SDKAppID,
    userID: tencent_accid,
    userSig: tencent_token,
    useUploadPlugin: true,
    framework: `vue${vueVersion}`,
  };
  let path = router.history._startLocation;
  path != "/home" &&
    router.currentRoute &&
    tencent_accid &&
    tencent_token &&
    TUILogin.login(loginInfo).catch((error) => {
      Message.error({
        message: error,
      });
    });
});
function changeLanguage(language: string) {
  locale.value = language;
}
</script>
<style lang="scss">
@import "@/assets/scss/index.scss";
html,
body,
#app {
  width: 100%;
  height: 100%;
  margin: 0;
}
</style>
<style>
html {
  font-size: 16px;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    "Microsoft Yahei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  box-sizing: border-box;
  flex-shrink: 0;
}

#app {
  width: 100vw;
  height: 100vh;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.justify-start {
  display: flex;
  justify-content: flex-start;
}

.justify-center {
  display: flex;
  justify-content: center;
}

.justify-end {
  display: flex;
  justify-content: flex-end;
}

.justify-evenly {
  display: flex;
  justify-content: space-evenly;
}

.justify-around {
  display: flex;
  justify-content: space-around;
}

.justify-between {
  display: flex;
  justify-content: space-between;
}

.items-start {
  display: flex;
  align-items: flex-start;
}

.items-center {
  display: flex;
  align-items: center;
}

.items-end {
  display: flex;
  align-items: flex-end;
}
.view {
  width: 100%;
  height: 100%;
}
#app .el-table .has-gutter {
  color: #fff;
}
/* .el-table .has-gutter th.el-table__cell {
  background: #1d7bfc;
} */
#app .el-table .has-gutter .cell {
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
}
/* #app .el-button--primary {
  background-color: #1d7bfc;
  border-color: #1d7bfc;
} */
.pagination {
  /* height: 50px; */
  margin-top: 10px;
  padding: 0 30px;
}
/* #app .tablefixed.is-leaf {
  background-color: #1d7bfc;
  color: #fff;
  font-weight: 500;
}
#app .tablefixed.is-leaf .cell {
  font-size: 16px;
} */
</style>

